import { render, staticRenderFns } from "./add-user-popup.vue?vue&type=template&id=6b421b0a&"
import script from "./add-user-popup.vue?vue&type=script&lang=js&"
export * from "./add-user-popup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports